import React from 'react';
import { Header } from "semantic-ui-react";

const LocationsHeader = () => {
    return (
        <Header
            as="h3"
            className="headerAlign"
        >
             Manage Locations
        </Header>
    )
}

export default LocationsHeader